import axios from "axios";
import { success, info, error, warning, clear } from "toastr";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_APIKEY + "/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(config => {
  if (config.method == "put") {
    console.log(config.data);
    delete config.data.updatedAt;
    delete config.data.createdAt;
    delete config.data.otpValid;
    delete config.data.otp;
  }
  const user = JSON.parse(localStorage.getItem("authUser"));
  if (user?.token) {
    config.headers.common["Authorization"] = `Bearer ${user.token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    if (
      (response && response.status === 200) ||
      response.status === 201 ||
      response.status === 202
    ) {
      console.log("if");
      return Promise.resolve(response);
    } else {
      console.log("ghdughudfi");
      return Promise.reject(response);
    }
  },
  err => {
    if (err && err.response && err.response.status == 409) {
      warning(
        err.response.data && err.response.data.message
          ? err.response.data.message
          : "Record already exist"
      );
      return err;
    } else if (err && err.response && err.response.status == 400) {
      warning(
        err.response.data && err.response.data.message
          ? err.response.data.message
          : "Data Not Found"
      );
      return err;
    } else if (err == "Error: Network Error") {
      error("સર્વર જવાબ નથી દહીં રહ્યું. કૃપયા થોડા સમય પછી પ્રયાસ કરો ");
      return;
    } else if (err && err.response && err.response.status === 401) {
      localStorage.removeItem("authUser");
      error("please login again");
      window.location.href = "/login";
      reject(null);
    } else {
      return new Promise(async (resolve, reject) => {
        if (err && err.response && err.response.data) reject(err.response.data);
        else reject({});
      });
    }
  }
);

export const baseUrl = process.env.REACT_APP_APIKEY;

// user login api

export const loginUserAPI = async data => {
  let result;
  try {
    result = await axiosInstance.post("/users/login", data).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);

    console.log(err);
  }
  return result;
};

// Admin create user api
export const createUser = async data => {
  let result;
  try {
    result = await axiosInstance.post("/users/register", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// Admin create user api
export const updateUser = async data => {
  let result;
  let id = data.id;
  try {
    result = await axiosInstance.put(`/users/${id}`, data.data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

//password Change API
export const changePasswordApi = async data => {
  let result;
  try {
    result = await axiosInstance.put("users/updatePassword", data).then(res => {
      return res;
    });
  } catch (err) {
    return err;
  }
  return result;
};

// Add unit api
export const addUnitAPI = async data => {
  let result;
  try {
    result = await axiosInstance.post("/factory", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// Add remainder api
export const addRemainderAPI = async data => {
  let result;
  try {
    result = await axiosInstance.post("/remainders", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// Add cash payment api
export const addCashPaymentAPI = async data => {
  let result;
  try {
    result = await axiosInstance.post("/payments", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update cash payment api
export const updateCashPaymentAPI = async ({ id, data }) => {
  console.log(id);
  let result;
  try {
    result = await axiosInstance.put(`/payments/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    return err;
  }
  return result;
};

// Add unit api
export const updateUnitAPI = async data => {
  let result;
  try {
    result = await axiosInstance.put(`/factory/${data.id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get unit api
export const getUnitAPI = async ({ isInternal, name, page, limit }) => {
  let result;
  let urlString = "/factory/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (isInternal) {
    urlString += `&isInternal=${isInternal}`;
  } else if (isInternal == false) {
    urlString += `&isInternal=${isInternal}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get payment api
export const getPaymentAPI = async ({ id, page, limit }) => {
  let result;
  let url = "/payments/ledger/";
  if (page && limit) {
    urlString += `?page=${page}&limit=${limit}`;
  }
  try {
    result = await axiosInstance.get(`${url}${id}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get payment api
export const getDashboardPaymentAPI = async ({ page, limit }) => {
  let result;
  let urlString = `/payments/`;
  if (page && limit) {
    urlString += `?page=${page}&limit=${limit}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get remainder api
export const getRemainderAPI = async ({ page, limit }) => {
  let result;
  let url = "/remainders/";
  if (page && limit) {
    urlString += `?page=${page}&limit=${limit}`;
  }
  try {
    result = await axiosInstance.get(`${url}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err.message);
    console.log(err);
  }
  return result;
};
// get remainder api
export const getRemainderByIdAPI = async ({ page, limit, ledgerId }) => {
  let result;
  let url = "/remainders/ledger/";
  if (page && limit) {
    urlString += `?page=${page}&limit=${limit}`;
  }
  try {
    result = await axiosInstance.get(`${url}${ledgerId}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err.message);
    console.log(err);
  }
  return result;
};

// get roles api
export const getRoleAPI = async () => {
  let result;
  try {
    result = await axiosInstance
      .get("/roles")
      .then(res => {
        if (res) return res.data;
        else return {};
      })
      .catch(err => console.log(err));
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
  getByRoleI;
};

// get getUserByRoleId api
export const getUserByRoleId = async id => {
  let result;
  try {
    result = await axiosInstance.get(`/users/getByRoleId/${id}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get userTimeShift api
export const getUserTimeShiftAPI = async () => {
  let result;
  try {
    result = await axiosInstance.get("/userTimeShift").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add party api
export const createPartyApi = async data => {
  let result;
  try {
    result = await axiosInstance.post("/party", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get add party api
export const getPartyApi = async ({ page, limit, name, partyCode }) => {
  let result;
  let urlString = "/party/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (partyCode) {
    urlString += `&partyCode=${partyCode}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update party api
export const updatePartyApi = async data => {
  let result;
  let id = data.id;
  try {
    result = await axiosInstance.put(`/party/${id}`, data.data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get organisation api
export const getOrganisationSetting = async () => {
  let result;
  try {
    result = await axiosInstance.get("/organizationSettings").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add organization api
export const addOrganisationSetting = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/organizationSettings", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update organosation api
export const updateOrganisation = async (id, data) => {
  let result;
  try {
    result = await axiosInstance.put(`/organizations/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get userProfile api
export const getUserProfileApi = async () => {
  let result;
  try {
    result = await axiosInstance.get("/users/profile").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get userProfile api
export const updateUserProfileApi = async data => {
  let result;
  try {
    result = await axiosInstance.put("/users", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get adminUserProfile api
export const getAdminUserProfileApi = async () => {
  let result;

  try {
    result = await axiosInstance.get("/adminusers/profile").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get adminUserProfile api
export const updateAdminUserProfileApi = async data => {
  let result;
  delete data.role;
  try {
    result = await axiosInstance.put("/adminusers", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get user api
export const getUserApi = async ({ page, limit, roleId, factoryId, name }) => {
  let result;
  let urlString = "/users/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (roleId) {
    urlString += `&roleId=${roleId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get cubebelt api
export const getCubeBelts = async ({ page, limit }) => {
  let result;
  let urlString = "/cubeBelts/inwardStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const getCube = async ({
  page,
  limit,
  fromDate,
  toDate,
  machineOperatorId,
  beltId,
  fillerId,
  name,
}) => {
  let result;
  let urlString = "/cubeBelts/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (machineOperatorId) {
    urlString += `&machineOperatorId=${machineOperatorId}`;
  }
  if (beltId) {
    urlString += `&beltId=${beltId}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (fillerId) {
    urlString += `&fillerId=${fillerId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get cube api
export const getCubesWithProcessId = async ({ id, cubeBeltId, fillerId }) => {
  let result;
  let urlString = "/cubeBelts/process/?";
  if (id) {
    urlString += `processId=${id}`;
  }
  if (cubeBeltId) {
    urlString += `&cubeBeltId=${cubeBeltId}`;
  }
  if (fillerId) {
    urlString += `&fillerId=${fillerId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get cubeList api
export const getCubesList = async ({ processId, cubeBeltId }) => {
  let result;
  let urlString = "/cubeBelts/?";
  if (processId) {
    urlString += `processId=${processId}`;
  }
  if (cubeBeltId) {
    urlString += `&cubeBeltId=${cubeBeltId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get cubeList api
export const getCubeId= async () => {
  let result;
  let urlString = "/cubeBelts/lastBeltId/";
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get cubeList api
export const getSummaryStock= async () => {
  let result;
  let urlString = "/machineOperatorStocks/stocksummary/";
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};


// create belt
export const addCubes = async data => {
  let result;
  try {
    result = await axiosInstance.post("/cubeBelts", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update cube belt
export const updateCubes = async ({ id, data }) => {
  let result;
  console.log(id, data);
  try {
    result = await axiosInstance.put(`/cubeBelts/BELT${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update machine operator list
export const updateMachineOperatorStocks = async ({ id, data }) => {
  let result;
  console.log(id, data);
  try {
    result = await axiosInstance
      .put(`/machineOperatorStocks/BELT${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update cube belt
export const assignCubes = async ({ id, data }) => {
  let result;
  console.log(id, data);
  try {
    result = await axiosInstance
      .put(`/cubeBelts/assignCube/BELT${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get organization api
export const getOrganizatioanApi = async () => {
  let result;
  try {
    result = await axiosInstance.get("/organizations").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add shapes api
export const addShapes = async data => {
  let result;
  try {
    result = await axiosInstance.post("/shapes", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// delete shapes api
export const deleteShapes = async id => {
  let result;
  try {
    result = await axiosInstance.delete(`/shapes/${id}`).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get shapes api
export const getShapes = async () => {
  let result;
  try {
    result = await axiosInstance.get("/shapes/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update shapes api
export const updateShapes = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/shapes/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};


// add process api
export const addProcess = async data => {
  let result;
  try {
    result = await axiosInstance.post("/processes", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// delete process api
export const deleteProcess = async id => {
  let result;
  try {
    result = await axiosInstance.delete(`/processes/${id}`).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get process api
export const getProcess = async () => {
  let result;
  try {
    result = await axiosInstance.get("/processes/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update process api
export const updateProcess = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/processes/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};






// add Bank api
export const addBanks = async data => {
  let result;
  try {
    result = await axiosInstance.post("/banks", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// delete banks api
export const deleteBanks = async id => {
  let result;
  try {
    result = await axiosInstance.delete(`/banks/${id}`).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get banks api
export const getBanks = async () => {
  let result;
  try {
    result = await axiosInstance.get("/banks/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update banks api
export const updateBanks = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/banks/${id}`, data).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add inclusions api
export const addInclusion = async data => {
  let result;
  try {
    result = await axiosInstance.post("/inclusions", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const deleteInclusion = async id => {
  let result;
  try {
    result = await axiosInstance.delete(`/inclusions/${id}`).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add inclusions api
export const getInclusion = async () => {
  let result;
  try {
    result = await axiosInstance.get("/inclusions/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update inclusions api
export const updateInclusion = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/inclusions/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add Categories api
export const addCategories = async data => {
  let result;
  try {
    result = await axiosInstance.post("/categories", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const deleteCategories = async id => {
  let result;
  try {
    result = await axiosInstance.delete(`/categories/${id}`).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add Categories api
export const getCategories = async () => {
  let result;
  try {
    result = await axiosInstance.get("/categories/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update Categories api
export const updateCategories = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/categories/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add material item api
export const addMaterialItam = async data => {
  let result;
  try {
    result = await axiosInstance.post("/items", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const deleteMaterialItem = async id => {
  let result;
  try {
    result = await axiosInstance.delete(`/items/${id}`).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get material item api
export const getMaterialItam = async ({ page, limit }) => {
  let result;
  let urlString = "/items/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update material item api
export const updateMaterialItam = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/items/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get ledgers
export const getLedgers = async ({
  page,
  limit,
  type,
  name,
  toDate,
  fromDate,
  partyId,
  ledgerStatus,
  paymentStatus,
  orderId,
  printStatus,
  factoryId,
  approveStatus,
}) => {
  let result;
  let urlString = "/ledgers/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}&`;
  }
  if (type) {
    urlString += `type=${type}&`;
  }
  if (partyId) {
    urlString += `partyId=${partyId}&`;
  }
  if (ledgerStatus) {
    urlString += `ledgerStatus=${ledgerStatus}&`;
  }
  if (printStatus) {
    urlString += `printStatus=${printStatus}&`;
  }
  if (orderId) {
    urlString += `orderId=${orderId}&`;
  }
  if (paymentStatus) {
    urlString += `paymentStatus=${paymentStatus}&`;
  }
  if (name) {
    urlString += `name=${name}&`;
  }
  if (factoryId) {
    urlString += `factoryId=${factoryId}&`;
  }
  if (approveStatus) {
    urlString += `approveStatus=${approveStatus}&`;
  }
  if (toDate) {
    urlString += `toDate=${toDate}&`;
  }
  if (fromDate) {
    urlString += `fromDate=${fromDate}&`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update ledger
export const updateLedgers = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/ledgers/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// create ledget
export const createLedger = async data => {
  let result;
  try {
    result = await axiosInstance.post("/ledgers", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add purchased item
export const addPurchasedItem = async data => {
  let result;
  try {
    result = await axiosInstance.post("/purchasedItems", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update filler stock
export const updatePurchasedItem = async ({ data, id }) => {
  let result;
  try {
    result = await axiosInstance
      .put(`/purchasedItems/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get purchased item
export const getPurchasedItem = async ({
  piecesQuantity,
  page,
  limit,
  factoryId,
}) => {
  let result;
  let urlString = "/purchasedItems/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (piecesQuantity) {
    urlString += `&piecesQuantity=${piecesQuantity}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get allocate material item
export const getAllocateMaterialItem = async ({ page, limit, factoryId }) => {
  let result;
  let urlString = "/allocateMaterials/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// purchaseItemsGetByFactoryId
export const purchaseItemsGetByFactoryId = async id => {
  let result;
  try {
    result = await axiosInstance
      .get(`/purchasedItems/factory/${id}`)
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add new stock in sales office
export const addNewStockSales = async data => {
  let result;
  try {
    result = await axiosInstance.post("/jangads", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add new stock in sales office
export const getStockInward = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
  dataEntryStatus,
  isInternal,
  paymentStatus,
  outWardStatus,
  name,
}) => {
  let result;
  let urlString = "/jangads/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (dataEntryStatus) {
    urlString += `&dataEntryStatus=${dataEntryStatus}`;
  }
  if (isInternal) {
    urlString += `&isInternal=${isInternal}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (outWardStatus) {
    urlString += `&outWardStatus=${outWardStatus}`;
  }
  if (paymentStatus) {
    urlString += `&paymentStatus=${paymentStatus}`;
  }

  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get party jangad
export const getPartyJangad = async ({ id, party }) => {
  let result;
  let urlString = "/jangads/partyJangad/";

  try {
    result = await axiosInstance.get(`${urlString}${party}/${id}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add new stock in sales office
export const getMainStockInward = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
  mdataEntryStatus,
}) => {
  let result;
  let urlString = "/jangads/mainJangads/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (mdataEntryStatus) {
    urlString += `&mdataEntryStatus=${mdataEntryStatus}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }

  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add new stock in sales office
export const getStockWithDataEntry = async ({
  page,
  limit,
  dataEntryStatus,
  partyId,
}) => {
  let result;
  let urlString = "/jangads/stocksWithDataEntry/?";
  console.log(partyId);
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (dataEntryStatus) {
    urlString += `&dataEntryStatus=${dataEntryStatus}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get data entry stock
export const getDataEntryStock = async ({
  page,
  limit,
  partyId,
  orderId,
  graderId,
  factoryId,
  fromDate,
  toDate,
  graderStatus,
  progressStatus,
  graderUserId,
  mdataEntryStatus,
  name,
}) => {
  let result;
  let urlString = "/dataEntryStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (graderStatus) {
    urlString += `&graderStatus=${graderStatus}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (graderUserId) {
    urlString += `&graderUserId=${graderUserId}`;
  }
  if (progressStatus) {
    urlString += `&progressStatus=${progressStatus}`;
  }
  if (mdataEntryStatus) {
    urlString += `&mdataEntryStatus=${mdataEntryStatus}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (graderId) {
    urlString += `&graderId=${graderId}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }

  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get data entry pending stock
export const getDataEntryPendingStock = async () => {
  let result;

  try {
    result = await axiosInstance
      .get("/dataEntryStocks/pendingStocks/")
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get data entry inward stock
export const getDataEntryInwardStock = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
}) => {
  let result;
  let urlString = "/dataEntryStocks/inwardStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }

  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get data entry outward stock
export const getDataEntryOutwardStock = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  graderUserId,
  fromDate,
  toDate,
  dataEntryStatus,
  name,
}) => {
  let result;
  let urlString = "/graderOutWardStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (dataEntryStatus) {
    urlString += `&dataEntryStatus=${dataEntryStatus}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (graderUserId) {
    urlString += `&graderUserId=${graderUserId}`;
  }

  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get data entry rejected stock
export const getDataEntryRejectedStock = async () => {
  let result;

  try {
    result = await axiosInstance
      .get("/dataEntryStocks/rejectStocks/")
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get grader pending stock list
export const getGraderPendingStock = async () => {
  let result;
  try {
    result = await axiosInstance
      .get("/graderStocks/pendingStocks/")
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get grader inward stock list
export const getGraderInwardStock = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
}) => {
  let result;
  let urlString = "/graderStocks/inwardStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }

  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get grader reject stock list
export const getGraderRejectStock = async () => {
  let result;

  try {
    result = await axiosInstance
      .get("/graderStocks/rejectStocks/")
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get grader pending stock list
export const getFillerPendingStock = async () => {
  let result;
  try {
    result = await axiosInstance
      .get("/fillerStocks/pendingStocks/")
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get grader inward stock list
export const getFillerInwardStock = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
}) => {
  let result;
  let urlString = "/fillerStocks/inwardStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }

  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get sales outward list
export const salesOfficeOutWardStocks = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
  salesOfficeStatus,
  name,
}) => {
  let result;
  let urlString = "/dataEntryOutWardStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (salesOfficeStatus) {
    urlString += `&salesOfficeStatus=${salesOfficeStatus}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }

  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get sales outward list for generate  ledger
export const generateLedgersalesOfficeOutWardStocks = async ({
  page,
  limit,
  partyId,
  factoryId,
  salesOfficeStatus,
  toDate,
  fromDate,
  name,
  ledgerId,
  ledgerStatus,
  ledgerIdF,
  ledgerStatusF,
  isParty,
}) => {
  let result;
  let urlString = "/salesOfficeOutWardStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (ledgerStatus) {
    urlString += `&ledgerStatus=${ledgerStatus}`;
  }
  if (ledgerStatusF) {
    urlString += `&ledgerStatusF=${ledgerStatusF}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (isParty) {
    urlString += `&isParty=${isParty}`;
  } else {
    urlString += `&isParty=${isParty}`;
  }
  if (salesOfficeStatus) {
    urlString += `&salesOfficeStatus=${salesOfficeStatus}`;
  }
  if (ledgerId) {
    urlString += `&ledgerId=${ledgerId}`;
  }
  if (ledgerIdF) {
    urlString += `&ledgerIdF=${ledgerIdF}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

//  view jangad timeline
export const viewJangadTimeLine = async ({
  id,
  isParty,
  partyJangadNo,
  graderUserId,
}) => {
  let result;
  let urlString = `/jangads/timeline/${id}?isParty=${isParty}&partyJangadNo=${partyJangadNo}`;
  if (graderUserId) {
    urlString += `&graderUserId=${graderUserId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get grader reject stock list
export const getFillerRejectStock = async () => {
  let result;

  try {
    result = await axiosInstance
      .get("/fillerStocks/rejectStocks/")
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add data entry stock
export const addDataEntryStock = async data => {
  let result;
  try {
    result = await axiosInstance.post("/dataEntryStocks", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// add data entry stock
export const addSalesExpressInward = async data => {
  let result;
  try {
    result = await axiosInstance.post("/expressInwards", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const addDataEntryOutwards = async data => {
  let result;
  try {
    result = await axiosInstance.post("/expressInwardDataEntryOutwards", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const getDataEntryOutwards = async (id) => {
  let result;
  try {
    result = await axiosInstance.get(`/expressInwardDataEntryOutwards/${id}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    //error(err);
    console.log(err);
  }
  return result;
};
export const addPartyOutwards = async data => {
  let result;
  try {
    result = await axiosInstance.post("/expressInwardPartyOutwards/outwards", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const getPartyOutwards = async (id) => {
  let result;
  try {
    result = await axiosInstance.get(`/expressInwardPartyOutwards/${id}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const getExpressInwardApi = async ({ page,
  
  limit,
  partyId,
  jangadId,
  factoryId,
  fromDate,
  toDate,
  outWardStatus,
  dateFilterType,}) => {
  let result;
  let urlString = "/expressInwards/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (jangadId) {
    urlString += `&jangadId=${jangadId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (outWardStatus) {
    urlString += `&outWardStatus=${outWardStatus}`;
  }
  if (dateFilterType) {
    urlString += `&dateFilterType=${dateFilterType}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// reassign jangad
export const addReassignJangad = async data => {
  let result;
  try {
    result = await axiosInstance.post("/jangads/reassign/", data).then(res => {
      if (res.data)
        if (res.success == true) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

//  data entry outward stock
export const dataEntryOutWardStocks = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/dataEntryOutWardStocks", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

//  data entry outward stock
export const addSalesOfficeOutWardStocks = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/salesOfficeOutWardStocks", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update grader  stock
export const addGraderStock = async data => {
  let result;
  try {
    result = await axiosInstance.post("/graderStocks", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get grader  stock
export const getGraderStock = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
  assignStatus,
  name,
  fillerStatus
}) => {
  let result;
  let urlString = "/graderStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (assignStatus) {
    urlString += `&assignStatus=${assignStatus}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (fillerStatus) {
    urlString += `&fillerStatus=${fillerStatus}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add filler stock
export const addFillerStock = async data => {
  let result;
  try {
    result = await axiosInstance.post("/fillerStocks", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// update filler stock
export const updateFillerStock = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance
    .put(`/fillerStocks/${id}`, data)
    .then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get grader  stock
export const getFillerStockList = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
  assignStatus,
  graderUserId,
  name,
}) => {
  let result;
  let urlString = "/fillerStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (graderUserId) {
    urlString += `&graderUserId=${graderUserId}`;
  }
  if (assignStatus) {
    urlString += `&assignStatus=${assignStatus}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// get grader  stock
export const getFillerProcessStockList = async ({ page, limit }) => {
  let result;
  let urlString = "/fillerStocks/processStock/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// get grader  stock
export const getGraderProcessStockList = async ({
  page,
  limit,
  boilManId,
  machineOperatorId,
  toDate,
  fromDate,
  beltId,
}) => {
  let result;
  let urlString = "/graderStocks/processStock/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  }
  if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (boilManId) {
    urlString += `&boilManId=${boilManId}`;
  }
  if (machineOperatorId) {
    urlString += `&machineOperatorId=${machineOperatorId}`;
  }
  if (beltId) {
    urlString += `&beltId=${beltId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// get grader  stock
export const getFillerAcceptedProcessStockList = async ({
  page,
  limit,
  dataEntryAcceptStatus,
  salesOfficeAcceptStatus,
}) => {
  let result;
  let urlString = "/fillerStocks/acceptedProcessStock/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (dataEntryAcceptStatus) {
    urlString += `&dataEntryAcceptStatus=${dataEntryAcceptStatus}`;
  }
  if (salesOfficeAcceptStatus) {
    urlString += `&salesOfficeAcceptStatus=${salesOfficeAcceptStatus}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get filler dashboard  stock
export const getFillerStock = async ({
  page,
  limit,
  fillerStatus,
  fromDate,
  toDate,
}) => {
  let result;
  let urlString = "/assignGraderToFillerStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (fillerStatus) {
    urlString += `&fillerStatus=${fillerStatus}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get assign to filler stock  stock
export const assignGraderToFillerStocks = async ({
  page,
  limit,
  fromDate,
  toDate,
}) => {
  let result;
  let urlString = "/assignGraderToFillerStocks/inwardStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// get assign to filler reject  stock
export const assignGraderToFillerRejectStocks = async ({ page, limit }) => {
  let result;
  let urlString = "/assignGraderToFillerStocks/rejectStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add new stock in sales office
export const updateStockInward = async data => {
  let result;
  let id = data.id;
  delete data.id;
  delete data.dataEntryStatus;
  try {
    result = await axiosInstance.put(`/jangads/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const updateExpressInward = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/expressInwards/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const updateOutward = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance.put(`/expressInwardDataEntryOutwards/outward/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const getExpressInwardById = async id => {
  let result;
  try {
    result = await axiosInstance.get(`/expressInwards/${id}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// add new stock in sales office
export const updatesalesOfficeOutWardStocks = async data => {
  let result;
  let id = data.id;
  delete data.id;
  delete data.dataEntryStatus;
  try {
    result = await axiosInstance
      .put(`/salesOfficeOutWardStocks/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const updateDataEntryStock = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance
      .put(`/dataEntryStocks/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update stock with dataEntry
export const updateStockWithDataEntry = async data => {
  console.log(data);
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance
      .put(`/jangads/stocksWithDataEntry/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const updateGraderStock = async ({ id, data }) => {
  let result;
  try {
    result = await axiosInstance.put(`/graderStocks/${id}`, data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// data entry update stock list
export const updateGraderStockInWard = async ({ id, data }) => {
  let result;
  try {
    result = await axiosInstance
      .put(`/stockGraderInWards/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add grader assign stock list
export const addGraderAssignStockList = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/assignGraderToFillerStocks", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// grader outward
export const graderOutWardStocks = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/graderOutWardStocks", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// grader outward
export const updateGraderOutWardStocks = async ({ data, id }) => {
  let result;
  try {
    result = await axiosInstance
      .put(`/graderOutWardStocks/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const acceptGraderDiamonds = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/stockGraderOutWards", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const assignGraderToFillerInWards = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/assignGraderToFillerInWards", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update grader assign stock
export const updateGraderAssignStock = async ({ data, id }) => {
  console.log(data, id);
  let result;
  try {
    result = await axiosInstance
      .put(`/assignGraderToFillerStocks/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const allocateMaterial = async data => {
  let result;
  try {
    result = await axiosInstance.post("/allocateMaterials", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const updateallocateMaterial = async ({ data, id }) => {
  let result;
  try {
    result = await axiosInstance
      .put(`/allocateMaterials/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const addStockFillerInWards = async data => {
  let result;
  try {
    result = await axiosInstance.post("/stockFillerInWards", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const addAssignCubesFillerToMachinOperators = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/assignCubesFillerToMachinOperators", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const updateAssignCubesFillerToMachinOperators = async data => {
  let result;
  let id = data.id;

  delete data.id;
  try {
    result = await axiosInstance
      .put(`/assignCubesFillerToMachinOperators/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const getCubeList = async ({ page, limit, partyId, cubeId }) => {
  let result;
  let urlString = "/stockFillerInWards/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (cubeId) {
    urlString += `&cubeId=${cubeId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const rejectDiamondByGrader = async ({
  page,
  limit,
  partyId,
  orderId,
  name,
  factoryId,
  diamondStatus,
  rejectStatus,
  fromDate,
  toDate,
  assignStatus,
  ar,
  status,
}) => {
  let result;
  let urlString = "/stockGraderInWards/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (ar) {
    urlString += `&ar=${ar}`;
  } else {
    urlString += `&ar=${ar}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (diamondStatus) {
    urlString += `&diamondStatus=${diamondStatus}`;
  }
  if (rejectStatus) {
    urlString += `&rejectStatus=${rejectStatus}`;
  }
  if (assignStatus) {
    urlString += `&assignStatus=${assignStatus}`;
  }
  if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  }
  if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (status) {
    urlString += `&status=${status}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// data entry update stock list
export const rejectDiamondByDataEntry = async ({
  page,
  limit,
  partyId,
  orderId,
  name,
  factoryId,
  diamondStatus,
  rejectStatus,
  assignStatus,
  ar,
  status,
}) => {
  let result;
  let urlString = "/stockDataEntryInWards/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (ar) {
    urlString += `&ar=${ar}`;
  } else {
    urlString += `&ar=${ar}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (diamondStatus) {
    urlString += `&diamondStatus=${diamondStatus}`;
  }
  if (rejectStatus) {
    urlString += `&rejectStatus=${rejectStatus}`;
  }
  if (assignStatus) {
    urlString += `&assignStatus=${assignStatus}`;
  }
  if (status) {
    urlString += `&status=${status}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// filler get stock list
export const getAssignCubesFillerToMachinOperators = async ({
  page,
  limit,
  date,
  machineOperatorStatus,
  machineOperatorId,
}) => {
  let result;
  let urlString = "/cubeBelts/assignCube/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (date) {
    urlString += `&date=${date}`;
  }
  if (machineOperatorStatus) {
    urlString += `&machineOperatorStatus=${machineOperatorStatus}`;
  }
  if (machineOperatorId) {
    urlString += `&machineOperatorId=${machineOperatorId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// filler get stock list
export const getMachineOperatorStock = async ({
  page,
  limit,
  fromDate,
  toDate,
  beltId,
  name,
  fillerId,
  graderStatus,
  boilManId,
}) => {
  let result;
  let urlString = "/machineOperatorStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (graderStatus) {
    urlString += `&graderStatus=${graderStatus}`;
  }
  if (beltId) {
    urlString += `&beltId=${beltId}`;
  }
  if (boilManId) {
    urlString += `&boilManId=${boilManId}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  if (fillerId) {
    urlString += `&fillerId=${fillerId}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// /assignGraderToFillerInWards/repeats/
export const assignGraderToFillerInWardsRepeats = async ({
  page,
  limit,
  dataEntryStatus,
  fillerStatus,
  partyId,
  factoryId,
  fromDate,
  orderId,
  toDate,
  name,
}) => {
  let result;
  let urlString = "/assignGraderToFillerInWards/repeats/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (dataEntryStatus) {
    urlString += `&dataEntryStatus=${dataEntryStatus}`;
  }
  if (fillerStatus) {
    urlString += `&fillerStatus=${fillerStatus}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  }
  if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// /assignGraderToFillerInWards
export const getAssignGraderToFillerStocks = async ({
  page,
  limit,
  graderStatus,
  partyId,
  fillerStatus,
  factoryId,
  fromDate,
  orderId,
  toDate,
  fillerId,
  name,
}) => {
  let result;
  let urlString = "/assignGraderToFillerStocks/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (graderStatus) {
    urlString += `&graderStatus=${graderStatus}`;
  }
  if (fillerStatus) {
    urlString += `&fillerStatus=${fillerStatus}`;
  }
  if (fillerId) {
    urlString += `&fillerId=${fillerId}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  }
  if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// machine operator stock list
export const addMachineOperaterStock = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/machineOperatorStocks", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// AssignCubes MachinOperators To Graders stock list
export const addAssignCubesMachinOperatorsToGraders = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/assignCubesMachinOperatorsToGraders", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update AssignCubes MachinOperators To Graders stock list
export const updateAssignCubesMachinOperatorsToGraders = async data => {
  console.log(data);
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance
      .put(`/assignCubesMachinOperatorsToGraders/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update AssignCubes MachinOperators To Graders stock list
export const acceptStockDataEntryInWards = async data => {
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance
      .put(`/stockDataEntryInWards/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// update AssignCubes MachinOperators To Graders stock list
export const updateAssignGraderToFillerInWards = async data => {
  console.log(data);
  let result;
  let id = data.id;
  delete data.id;
  try {
    result = await axiosInstance
      .put(`/assignGraderToFillerInWards/${id}`, data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// AssignCubes MachinOperators To Graders stock list
export const getAssignCubesMachinOperatorsToGraders = async ({
  page,
  limit,
  date,
  graderStatus,
}) => {
  let result;
  let urlString = "/assignCubesMachinOperatorsToGraders/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (date) {
    urlString += `&date=${date}`;
  }
  if (graderStatus) {
    urlString += `&graderStatus=${graderStatus}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// AssignCubes MachinOperators To Graders stock list
export const graderStocksCompleteStock = async ({
  page,
  limit,
  partyId,
  orderId,
  factoryId,
  fromDate,
  toDate,
  outWardStatus,
  name,
}) => {
  let result;
  let urlString = "/graderStocks/completeStock/?";
  if (page && limit) {
    urlString += `page=${page}&limit=${limit}`;
  }
  if (fromDate && toDate) {
    urlString += `&fromDate=${fromDate}&toDate=${toDate}`;
  } else if (fromDate) {
    urlString += `&fromDate=${fromDate}`;
  } else if (toDate) {
    urlString += `&toDate=${toDate}`;
  }
  if (partyId) {
    urlString += `&partyId=${partyId}`;
  }
  if (orderId) {
    urlString += `&orderId=${orderId}`;
  }
  if (factoryId) {
    urlString += `&factoryId=${factoryId}`;
  }
  if (outWardStatus) {
    urlString += `&outWardStatus=${outWardStatus}`;
  }
  if (name) {
    urlString += `&name=${name}`;
  }
  try {
    result = await axiosInstance.get(urlString).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add grader assign stock list
export const addprocessedStocks = async data => {
  let result;
  try {
    result = await axiosInstance.post("/processedStocks", data).then(res => {
      if (res.data) success("ok", "Success", { timeOut: 5000 });
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add stock with data entry
export const addStockWithDataEntry = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/jangads/stocksWithDataEntry", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const acceptDataEntryOutward = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/expressInwardDataEntryOutwards/accept", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const acceptDataEntryOutwardBySalesOffice = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/expressInwardDataEntryOutwards/outward/accept-by-sales", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

export const acceptReturnDataEntryOutward = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/expressInwardDataEntryOutwards/acceptReturn", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const returnDataEntryOutward = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/expressInwardDataEntryOutwards/return", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const dataEntryExpressOutward = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/expressInwardDataEntryOutwards/outwards", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// sales office dashboard
export const getStocksDashboard = async () => {
  let result;
  try {
    result = await axiosInstance.get("/jangads/dashboard/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
export const getExpressDashboard = async () => {
  let result;
  try {
    result = await axiosInstance.get("/expressInwards/dashboard/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
// data entry dashboard
export const getDataEntryDashboard = async () => {
  let result;
  try {
    result = await axiosInstance
      .get("/dataEntryStocks/dashboard/")
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// grader dashboard
export const getGraderDashboard = async () => {
  let result;
  try {
    result = await axiosInstance.get("/graderStocks/dashboard/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// filler dashboard
export const getFillerDashboard = async () => {
  let result;
  try {
    result = await axiosInstance.get("/fillerStocks/dashboard/").then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// machine operator dashboard
export const getMachineOperatorDashboard = async () => {
  let result;
  try {
    result = await axiosInstance
      .get("/machineOperatorStocks/dashboard/")
      .then(res => {
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// filler inward Stock List By Jangad Id
export const getFillerInwardStockList = async (jangadId) => {
  let result;
  try {
    result = await axiosInstance.get(`/fillerStocks/getByJangadId/${jangadId}`).then(res => {
      if (res) return res.data;
      else return {};
    });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};

// add stock with data entry
export const updateTotalOutwardWeight = async data => {
  let result;
  try {
    result = await axiosInstance
      .post("/graderOutWardStocks/totalOutwardWeight", data)
      .then(res => {
        if (res.data) success("ok", "Success", { timeOut: 5000 });
        if (res) return res.data;
        else return {};
      });
  } catch (err) {
    error(err);
    console.log(err);
  }
  return result;
};
